import React, { useContext, useEffect, useState } from "react";
import UserContext from "../../contexts/UserContext";
import Utils from "../../Utils";
import _ from "lodash";

const HrHeader = (props) => {
  const { logout, userData } = useContext(UserContext);
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className="bg-white shadow-md py-4 px-8 flex justify-between items-center header">
        <div className="flex items-center gap-8">
          <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Marriott Bonvoy" className="logo" />
          <span className="flex items-center gap-2">
            <i className="fas fa-hotel text-blue-600 text-xl"></i>
            <h3 className="text-lg font-semibold text-gray-700">Hotel Photography Lead Panel</h3>
          </span>
        </div>
        <nav>
          <ul className="flex space-x-6 font-bold">
            <li>
              <a href={`${process.env.PUBLIC_URL}/hotel-representative-dashboard`} className="text-gray-600 hover:text-blue-500">
                Dashboard
              </a>
            </li>
            <li>
              <a href={`${process.env.PUBLIC_URL}/resources`} className="text-gray-600 hover:text-blue-500">
                Photography Resource Hub
              </a>
            </li>
            <li>
              <a href={`${process.env.PUBLIC_URL}/hotel-representative-manage-photoshoots`} className="text-gray-600 hover:text-blue-500">
                Photoshoots
              </a>
            </li>
            <li className="flex items-center gap-2">
              <span>{userData?.name || "User"}</span>
              <a href="#" onClick={logout} title="Logout" className="text-gray-600 hover:text-blue-500">
                <i className="fas fa-sign-out-alt"></i>
              </a>
            </li>
          </ul>
        </nav>
      </header>
    </>
  );
};

export default HrHeader;
